import { ChangeDetectionStrategy, Component, inject, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-notify-me-dialog',
    templateUrl: './notify-me-dialog.component.html',
    styleUrls: ['./notify-me-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NotifyMeDialogComponent {
  fb = inject(FormBuilder);
  klaviyoEmailForm = this.fb.group(
    {
      email: ['', [Validators.required, Validators.email]],
    },
    { updateOn: 'submit' }
  );

  constructor(
    public dialogRef: MatDialogRef<NotifyMeDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      prefix: string;
      email?: string | null;
      [key: string]: any;
    }
  ) {
    if (data.email) {
      this.klaviyoEmailForm.patchValue({ email: data.email });
    }
  }
  closeDialog(): void {
    this.dialogRef.close('TODO');
  }

  submit() {
    if (this.klaviyoEmailForm.valid) {
      this.dialogRef.close(this.klaviyoEmailForm?.value?.email);
    }
  }
}
